<template>
<div id="introduction">
  <div class="introTitle">
    团队介绍
  </div>
  <span class="introInfo">
    武汉大学测绘遥感信息工程国家重点实验室实时智能遥感研究团队是由武汉大学二级教授、博士生导师眭海刚教授为学术带头人，3位正教授、4位副教授和多名科研助理及博硕士研究生组成的团队，主要研究实时摄影测量、遥感影像自动解译、时空大数据、多维GIS、空中飞行器、多传感器集成、无人系统集群等，科研成果已服务国家应急、测绘地理、国家林草、公共安全等多个领域成果应用，发表SCI、EI等300多篇学术论文，编写专著8部，软件著作权40项，授权发明专利80项，获国家科技进步一等奖1项、国家科技进步二等奖3项，测绘科技进步一等奖4项，教育部技术发明一等奖奖1项，教育部科技进步一等奖1项，军队科技进步奖2项。培养的学生多次获国内外大赛奖，毕业生分布在国内外高校、大型企事业单位等。团队拥有星载/机载处理硬件、多架无人机、大型私有云计算平台等硬件条件和多个遥感专业化系统与软件平台保障，一直站在国际最前沿和国家重大需求第一线。
  </span>
  <div class="introSubTitle">
    <span>带头人简介</span>
  </div>
  <span class="introInfo">
    眭海刚，武汉大学二级教授，博导，测绘遥感信息工程国家重点实验室副主任，先进研究院卫星应用研究室主任，国家级人才入选者，湖北省“双创战略团队”首席，光谷“3551”人才，国家重点研发项目负责人。长期从事感影像自动解译、时空大数据、多维GIS、空中飞行器、多传感器集成、无人系统集群等理论研究、技术攻关和装备研制，二十多年来主持国家重点研发计划、 国家973、国家863、国家自然科学基金、装发预研/型研等项目60余项，主持研制了我国第一代遥感评估应用装备并装备全国应用，联合国家减灾中心等单位主持研制了我国首套业务化运行 的遥感自然灾害监测评估系统，主持研制了湖北省时空信息云平台的研制工作并在我国首个县级智慧城市——智慧老河口得到成功应用；作为核心人员研制了我国首个真三维GIS软件—GeoScope， 是国产GIS软件吉奥之星的开创者之一。发表150多篇学术论文，出版专著6部，国家发明专利70项，软件著作权20项，获国家科技进步一等奖（2020）一项，国家科技进步一等奖（创新团队奖） （2015）一项，国家科技进步二等奖（2000、2012、2014）三项，军队科技进步一等奖（2010、2015）二项，测绘科技进步一等奖（2013、2017、2019、2021）四项，教育部技术发明一等奖 （2018）一项，教育部科技进步一等奖（2009）一项。
  </span>
  <div class="introSubTitle">
    <span>团队成员</span>
  </div>
  <div class="teamPerson">
    <div style="display: inline-block; position: relative" v-for="photo in photoLists1" :key="photo.url">
      <el-image
          class="personCard"
          :src="photo.url"
          fit="fill">
      </el-image>
      <div class="personInfo">
        <span style="font-weight: bold">{{photo.name}}</span> <br/>
        <span style="font-weight: bold">{{photo.synopsis}}</span>
      </div>
    </div>
  </div>

  <div class="teamPerson">
    <div style="display: inline-block; position: relative" v-for="photo in photoLists2" :key="photo.url">
      <el-image
          class="personCard"
          :src="photo.url"
          fit="fill">
      </el-image>
      <div class="personInfo">
        <span style="font-weight: bold">{{photo.name}}</span> <br/>
        <span style="font-weight: bold">{{photo.synopsis}}</span>
      </div>
    </div>
  </div>
  
  <div class="teamPerson">      
    <div style="display: inline-block; position: relative" v-for="photo in photoLists3" :key="photo.url">   
      <el-image
          class="personCard"
          :src="photo.url"
          fit="fill">
      </el-image>
      <div class="personInfo">
        <span style="font-weight: bold">{{photo.name}}</span> <br/>
        <span style="font-weight: bold">{{photo.synopsis}}</span>
      </div>
    </div>
  </div>

</div>
</template>

<script>
export default {
name: "Introduction",
  data(){
    return {
      photoLists1: [
        {
          name: "眭海刚教授",
          url: require("../../assets/img/people/shg.jpg"),
          synopsis:
              "二级教授，博导"
        },
        {
          name: "马国锐教授",
          url: require("../../assets/img/people/马国锐教授.png"),
          synopsis: "研究员，博导",
          // 主要研究方向为遥感影像目标检测识别、语义分割提取、灾害/损毁评估、大数据预测预警等。
        },
        {
          name: "孙开敏教授",
          url: require("../../assets/img/people/孙开敏教授.jpg"),
          synopsis: "教授，博导",
          // 主要研究方向为多源遥感影像变化检测、智能解译、时序分析以及无人机应用等。
        },
        {
          name: "肖志峰教授",
          url: require("../../assets/img/people/肖志峰副教授.png"),
          synopsis: "教授，博导",
          // 主要研究方向为计算机视觉、人工智能、大数据分析挖掘及在遥感应用等。
        }
        
        
        
        
        
        
      ],
      photoLists2: [

        {
          name: "刘俊怡副教授",
          url: require("../../assets/img/people/刘俊怡副教授.png"),
          synopsis: "副研究员，硕导",
            // 长期从事遥感图像处理方法的研究和软件平台开发工作，主要研究方向为合成孔径雷达（SAR）图像处理、配准与变化检测、典型目标提取等。
        },
        {
          name: "张锡宁副教授",
          url: require("../../assets/img/people/张锡宁副教授.png"),
          synopsis: "副教授，硕导",
          // 主要研究方向为多源数据集成与时空分析、地物状态评估与仿真建模分析、知识库与智能计算、地理信息系统与应用等。
        },
        {
          name: "雷俊峰副教授",
          url: require("../../assets/img/people/雷俊峰副教授.jpg"),
          synopsis: "副教授，硕导",
          // 主要研究方向为无人机软硬件集成等。
        },
        {
          name: "刘华俊副教授",
          url: require("../../assets/img/people/刘华俊副教授.jpg"),
          synopsis: "副教授，硕导",
        }
         
         
      ],

      photoLists3: [
        {
          name: "徐川副研究员",
          url: require("../../assets/img/people/徐川副研究员.jpg"),
          synopsis: "副研究员，硕导",
        },
        {
          name: "李洪利讲师",
          url: require("../../assets/img/people/李洪利讲师.png"),
          synopsis: "博士，讲师",
        },
        {
          name: "周明婷实验师",
          url: require("../../assets/img/people/周明婷实验师.png"),
          synopsis: "博士，实验师",
        }
        ,
        {
         name: "宋志娜讲师",
         url: require("../../assets/img/people/宋志娜讲师.png"),
         synopsis: "博士，讲师",
        },
        {
         name: "刘超贤讲师",
         url: require("../../assets/img/people/刘超贤讲师.png"),
         synopsis: "博士，讲师",
        }
      ],
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
#introduction {
  .introTitle{
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    font-weight: bolder;
    color: #076498;
    border-bottom: 1px solid #b1b1b1;
  }
  .introInfo {
    display: block;
    text-indent: 36px;
    text-align: justify;
    line-height: 26px;
    padding: 5px;
    font-size: 14px;
    color: #454545;
  }
  .introSubTitle{
    height: 25px;
    font-size: 16px;
    margin: 10px 0;
    padding: 0 10px;
    border-left: 3px solid #0098ec;
  }
  .teamPerson {
    padding: 5px 0;
    height: 160px;
    //width: 985px;
    display: flex;
    justify-content: space-between;
    .personCard {
      width: 120px;
      margin: 0 8px;
    }

    .personInfo {
      font-size: 14px;
      text-align: center;
      color: white;
      display: inline-block;
      width: 120px;
      height: 20px;
      background-color: rgba(7, 100, 152, 0.7);
      position: absolute;
      left: 8px;
      bottom: 5px;
      overflow: hidden;
    }

    .personInfo:hover {
      height: 40px;
    }

    .prev, .next {
      display: inline;
      height: 100%;
      width: 20px;
      background-color: rgba(7, 100, 152, 0.2);
    }

    .el-icon-arrow-left, .el-icon-arrow-right {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }

    .prev:hover, .next:hover {
      cursor: pointer;
    }

    .el-icon-arrow-left, .el-icon-arrow-right {
      margin: 72px auto;
      color: #076498;
      font-weight: bolder;
    }
  }
}
</style>
